<template>
  <div>
    <div v-if="isUpdateNotification">
      <m-icon
        size="20"
        type="clock-circle"
      />
    </div>
    <div v-else-if="isIntegration">
      <m-icon
        size="20"
        type="api"
      />
    </div>
    <div v-else-if="isReport">
      <m-icon
        size="20"
        type="file-pdf"
      />
    </div>
    <div v-else-if="!isBotActor">
      <user-avatar
        :user="feedEntry.actor"
        :size="28"
      />
    </div>
  </div>
</template>

<script>
import UserAvatar from 'shared/components/UserAvatar.vue';
import { feedEntryType } from 'shared/constants.json';

export default {
  name: 'FeedEntryIcon',
  props: {
    feedEntry: {
      type: Object,
      required: true,
    },
  },
  components: { UserAvatar },
  computed: {
    isBotActor() {
      return this.isUpdateNotification || this.isIntegration || this.isReport;
    },
    isUpdateNotification() {
      return [feedEntryType.updateNotification].includes(this.feedEntry.type);
    },
    isIntegration() {
      return [feedEntryType.dataSourceUnhealthy, feedEntryType.dataSourceDead, feedEntryType.dataSourceQueryError].includes(this.feedEntry.type);
    },
    isReport() {
      return [feedEntryType.reportReady].includes(this.feedEntry.type);
    },
  },
};
</script>
